const images = {
    vs: require("../assets/images/vs.png"),
};

export default images;
